import { LitElement, html } from '@hh/global.js';

class HHProductCard extends LitElement {
  static properties = {}

  constructor() {
    super()

    this.variantButtons = [...this.querySelectorAll('.js-swatch')]
  }

  connectedCallback() {
    super.connectedCallback()

    this.variantButtons.forEach((button) => {
      button.addEventListener('click', this.onClickHandler.bind(this))
    })

    const badges = this.querySelector('.card__header__badges')

    if(badges && badges.textContent.trim() === '') {
      this.querySelector('.card__header__badges').classList.add('is-empty');
    }

    this.querySelectorAll('.blur-image--loading').forEach((image) => {
      // get Image ID attribute
      const imageID = image.getAttribute('id')
      const loadedImage = this.querySelector(
        `#${imageID}:not(.blur-image--loading)`
      )

      if (loadedImage.complete) {
        this.loaded(image, loadedImage)
      } else {
        loadedImage.addEventListener('load', this.loaded(image, loadedImage))
      }
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.variantButtons.forEach((button) => {
      button.removeEventListener('click', this.onClickHandler)
    })
  }

  loaded(blurImage, loadedImage) {
    loadedImage.style.display = 'block'
    setTimeout(() => {
      blurImage.classList.add('loaded')
      // blurImage.remove()
    }, 500)
  }

  async onClickHandler(event) {
    event.preventDefault()

    await this.hideAllVariantImages()
    await this.showVariantImage(event)

    this.variantButtons.forEach((el) => {
      el.classList.remove('active')
    })

    event.target.classList.add('active')
  }

  async hideAllVariantImages() {
    this.querySelectorAll('[data-variant-color]').forEach((element) => {
      element.classList.remove('active')
    })
  }

  async showVariantImage(event) {
    const vname = event.target.dataset.variantName
    const selector = '[data-variant-color="' + vname + '"]'
    const swatch = this.querySelector(selector)
    swatch?.classList.add('active')
  }

  render() {
    return html`<slot></slot>`
  }
}

if (!customElements.get('hh-product-card')) {
  customElements.define('hh-product-card', HHProductCard);
}
